import { render, staticRenderFns } from "./DownloadOverview.vue?vue&type=template&id=3b9fd700&scoped=true"
import script from "./DownloadOverview.vue?vue&type=script&lang=js"
export * from "./DownloadOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9fd700",
  null
  
)

export default component.exports